import { BrowserModule, HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule, Injectable } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { WorksComponent } from './components/works/works.component';
import { WorkComponent } from './components/works/work/work.component';
import { SingleWorkComponent } from './components/works/single-work/single-work.component';
import { VideoModuleComponent } from './components/modules/video-module/video-module.component';
import { GalleryModuleComponent } from './components/modules/gallery-module/gallery-module.component';
import { CreditsModuleComponent } from './components/modules/credits-module/credits-module.component';
import { ContentModuleComponent } from './components/modules/content-module/content-module.component';
import { SliderModuleComponent } from './components/modules/slider-module/slider-module.component';
import { OwlModule } from 'ngx-owl-carousel';
import { MouseWheelDirective } from './directives/mousewheel.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BannerModuleComponent } from './components/modules/banner-module/banner-module.component';
import { FormsModule } from '@angular/forms';
import { OverlayComponent } from './components/works/single-work/modules/overlay/overlay.component';
import { InViewportModule } from 'ng-in-viewport';
import { RelatedPostsComponent } from './components/modules/related-posts/related-posts.component';
import { relatedPipe } from './pipes/related.pipe';
import { CompanyComponent } from './components/company/company.component';
import { ReelsComponent } from './components/reels/reels.component';
import { BannerModuleVideoComponent } from './components/modules/banner-module-video/banner-module-video.component';
import * as Hammer from 'hammerjs';
import { SortByPipe } from './pipes/sort-by.pipe';
import { searchWorkPipe } from './pipes/search-works.pipe';
import { workPipe } from './pipes/work.pipe';
import { HomeCategoriesComponent } from './components/home/modules/home-categories/home-categories.component';
import { HomeReelComponent } from './components/home/modules/home-reel/home-reel.component';
import { HomeCareerComponent } from './components/home/modules/home-career/home-career.component';
import { HomeVideoComponent } from './components/home/modules/home-video/home-video.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { HomeArticleInstagramComponent } from './components/home/modules/home-article-instagram/home-article-instagram.component';
import { BackgroundImageDirective } from './directives/backgroundimage.directive';
import { HttpClientModule } from '@angular/common/http';
import { InstagramItemComponent } from './components/home/modules/home-article-instagram/instagram-item/instagram-item.component';
import { RelatedOverlayComponent } from './components/modules/related-overlay/related-overlay.component';
import { InstaMobileComponent } from './components/home/modules/insta-mobile/insta-mobile.component';
import { CompanyItemComponent } from './components/company/modules/company-item/company-item.component';
import { FooterComponent } from './components/footer/footer.component';
import { ReelVideoComponent } from './components/reels/reel-video/reel-video.component';
import { LoaderComponent } from './components/loader/loader.component';
import { RandomOrderPipe } from './pipes/random-order.pipe';
import { ConnectComponent } from './components/connect/connect.component';

@Injectable()

export class MyHammerConfig extends HammerGestureConfig  {
  overrides = <any>{
    'swipe': { 
        touchAction: 'pan-y',
        inputClass: Hammer.TouchInput,
        direction: Hammer.DIRECTION_ALL ,
        threshold: 0,
        velocity: 0,
    },
  }
}
@NgModule({
 declarations: [
   AppComponent,
   HeaderComponent,
   HomeComponent,
   WorksComponent,
   WorkComponent,
   SingleWorkComponent,
   VideoModuleComponent,
   GalleryModuleComponent,
   CreditsModuleComponent,
   ContentModuleComponent,
   SliderModuleComponent,
   MouseWheelDirective,
   BackgroundImageDirective,
   BannerModuleComponent,
   relatedPipe,
   searchWorkPipe,
   SortByPipe,
   workPipe,
   OverlayComponent,
   RelatedPostsComponent,
   CompanyComponent,
   ReelsComponent,
   BannerModuleVideoComponent,
   HomeCategoriesComponent,
   HomeReelComponent,
   HomeCareerComponent,
   HomeVideoComponent,
   HomeArticleInstagramComponent,
   InstagramItemComponent,
   RelatedOverlayComponent,
   InstaMobileComponent,
   CompanyItemComponent,
   FooterComponent,
   ReelVideoComponent,
   LoaderComponent,
   RandomOrderPipe,
   ConnectComponent
 ],
 imports: [
   BrowserModule,
   HttpClientModule,
   BrowserAnimationsModule,
   AppRoutingModule,
   OwlModule,
   HammerModule,
   FormsModule,
   InViewportModule,
   MatProgressBarModule,
   
 ],
 providers: [
    {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        }
 ],
 bootstrap: [AppComponent]
})
export class AppModule { }